/**
 * Trader Crypto Pro: a second real-money account per client with its own Solana wallet. The Live
 * account keeps its USD balance in our ledger; money moves between the two as USDC through the
 * platform treasury wallet. Pro balances live on-chain (or on the simulated chain before a wallet
 * provider is configured).
 */
import { D } from './decimal.js';
export const DEFAULT_CRYPTO_PRO_SETTINGS = {
    enabled: true,
    swapFeeBps: 90,
    transferFeeUsd: '1',
    minTransferUsd: '10',
    solSeed: '0.02',
};
/** Swap fees above this are refused (5 %). */
export const MAX_SWAP_FEE_BPS = 500;
function usd(x, label, max) {
    const s = typeof x === 'number' ? String(x) : x;
    if (typeof s !== 'string' || !D.isValid(s) || D.from(s).isNeg() || D.from(s).gt(max))
        throw new Error(`${label} must be a number from 0 to ${max}`);
    return D.from(s).toString();
}
/** Validate settings from the admin form. */
export function parseCryptoProSettings(x) {
    try {
        if (!x || typeof x !== 'object')
            throw new Error('Settings must be an object');
        const o = x;
        if (typeof o.enabled !== 'boolean')
            throw new Error('enabled must be true or false');
        const bps = Number(o.swapFeeBps);
        if (!Number.isInteger(bps) || bps < 0 || bps > MAX_SWAP_FEE_BPS)
            throw new Error(`Swap fee must be a whole number of basis points from 0 to ${MAX_SWAP_FEE_BPS} (5%)`);
        const transferFeeUsd = usd(o.transferFeeUsd, 'Transfer fee', '100');
        const minTransferUsd = usd(o.minTransferUsd, 'Minimum transfer', '100000');
        if (D.from(minTransferUsd).lte(transferFeeUsd))
            throw new Error('The minimum transfer must be above the transfer fee');
        const solSeed = usd(o.solSeed, 'SOL for network fees', '1');
        return { ok: true, value: { enabled: o.enabled, swapFeeBps: bps, transferFeeUsd, minTransferUsd, solSeed } };
    }
    catch (e) {
        return { ok: false, error: e.message };
    }
}
/** Solana explorer link for a transaction, or null for simulated ones. */
export function solscanTx(sig, simulated) {
    return sig && !simulated ? `https://solscan.io/tx/${sig}` : null;
}
export function shortAddress(a, head = 4, tail = 4) {
    return a.length <= head + tail + 1 ? a : `${a.slice(0, head)}…${a.slice(-tail)}`;
}
//# sourceMappingURL=crypto-pro.js.map